// Error boundary for PDF components
import React from 'react';

export class PDFErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('PDF Component Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h3>PDF Generation Error</h3>
          <p>There was an error generating the PDF. Please try refreshing the page.</p>
        </div>
      );
    }

    return this.props.children;
  }
}